var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgSignposts(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M24.934 8.817L23.35 6.495a.4.4 0 00-.33-.172h-5.937V4.387A.392.392 0 0016.687 4h-2.374a.392.392 0 00-.396.387v1.936H9.563a.392.392 0 00-.396.387v4.645c0 .214.177.387.396.387h4.354v1.548H7.979a.4.4 0 00-.33.173l-1.583 2.322a.38.38 0 000 .43l1.584 2.322a.4.4 0 00.33.173h5.937v8.516H9.958a.392.392 0 00-.395.387c0 .214.177.387.395.387h11.5a.392.392 0 00.396-.387.392.392 0 00-.396-.387h-4.375V18.71h4.354a.392.392 0 00.396-.387v-4.646a.392.392 0 00-.396-.387h-4.354v-1.548h5.938a.4.4 0 00.33-.172l1.583-2.323a.38.38 0 000-.43zM14.708 4.774h1.584v1.549h-1.584V4.774zm1.584 22.452h-1.584V18.71h1.584v8.516zm4.75-13.161v3.87H8.19L6.871 16l1.32-1.935h12.85zm-6.334-.775v-1.548h1.584v1.548h-1.584zm8.101-2.322H9.959V7.097h12.85l1.32 1.935-1.32 1.936z"
  }));
}

export default SvgSignposts;